import { user } from 'core';
import { actions } from 'core/use-cases/user';
import { addPageAction } from 'core/utilities';
import { useDispatch } from 'react-redux';

export function useChangeCycle() {
  const dispatch = useDispatch();
  const {
    data: { resellerId, cycle },
  } = user.hooks.useUser();

  function goToNewCycle() {
    addPageAction('choose-new-cycle', { resellerId });
    dispatch(actions.changeCycle.request({ cycle: cycle.currentCycle }));
  }

  return {
    goToNewCycle,
  };
}
